// LobbyArea.js
import React, { useState } from "react";
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Stack,
  Divider,
  Avatar,
  Tabs,
  Tab,
  useTheme,
} from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import GroupAddIcon from "@mui/icons-material/GroupAdd";

function LobbyArea({ socket }) {
  const theme = useTheme();
  const [username, setUsername] = useState("");
  const [inputRoomCode, setInputRoomCode] = useState("");
  const [totalRounds, setTotalRounds] = useState(5);
  const [activeTab, setActiveTab] = useState(0);

  const handleCreateRoom = () => {
    if (username.trim()) {
      socket.emit("createRoom", {
        username,
        totalRounds,
        playerId: socket.playerId,
      });
    } else {
      alert("Please enter a username.");
    }
  };

  const handleJoinRoom = () => {
    if (username.trim() && inputRoomCode.trim()) {
      socket.emit("joinRoom", {
        roomCode: inputRoomCode.toUpperCase(),
        username,
        playerId: socket.playerId,
      });
    } else {
      alert("Please enter a username and room code.");
    }
  };

  const handleReconnect = () => {
    const playerId = localStorage.getItem("playerId");
    if (playerId) {
      if (username.trim() && inputRoomCode.trim()) {
        socket.emit("reconnectPlayer", {
          roomCode: inputRoomCode.toUpperCase(),
          username,
          playerId: socket.playerId,
        });
      } else {
        alert("Please enter a username and room code.");
      }
    } else {
      alert("Room not exists!");
    }
  };

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  // return (
  //   <Box
  //     sx={{
  //       display: "flex",
  //       justifyContent: "center",
  //       alignItems: "center",
  //       height: "100%",
  //       px: 2,
  //     }}
  //   >
  //     <Paper
  //       elevation={3}
  //       sx={{
  //         p: 4,
  //         borderRadius: 3,
  //         width: "100%",
  //         maxWidth: { xs: "100%", md: "50%" },
  //         background: "rgba(255,255,255,0.9)",
  //         backdropFilter: "blur(8px)",
  //       }}
  //     >
  //       <Typography
  //         variant="h5"
  //         align="center"
  //         gutterBottom
  //         sx={{ fontWeight: 600 }}
  //       >
  //         Welcome to the Game
  //       </Typography>

  //       <Tabs
  //         value={activeTab}
  //         onChange={handleTabChange}
  //         variant="fullWidth"
  //         sx={{ mb: 3 }}
  //       >
  //         <Tab label="Create Room" />
  //         <Tab label="Join Room" />
  //       </Tabs>

  //       {activeTab === 0 && (
  //         <Stack spacing={3}>
  //           <TextField
  //             fullWidth
  //             label="Username"
  //             value={username}
  //             onChange={(e) => setUsername(e.target.value)}
  //             inputProps={{ maxLength: 12 }}
  //           />

  //           <TextField
  //             fullWidth
  //             label="Total Rounds"
  //             type="number"
  //             value={totalRounds}
  //             onChange={(e) => setTotalRounds(e.target.value)}
  //             inputProps={{ min: 1, max: 20 }}
  //           />

  //           <Button
  //             variant="contained"
  //             color="primary"
  //             size="large"
  //             startIcon={<GroupAddIcon />}
  //             onClick={handleCreateRoom}
  //             disabled={!username.trim()}
  //             sx={{ py: 1.5, borderRadius: 2, textTransform: "none" }}
  //           >
  //             Create New Room
  //           </Button>
  //         </Stack>
  //       )}

  //       {activeTab === 1 && (
  //         <Stack spacing={3}>
  //           <TextField
  //             fullWidth
  //             label="Username"
  //             value={username}
  //             onChange={(e) => setUsername(e.target.value)}
  //             inputProps={{ maxLength: 12 }}
  //           />

  //           <TextField
  //             fullWidth
  //             label="Room Code"
  //             value={inputRoomCode}
  //             onChange={(e) => setInputRoomCode(e.target.value.toUpperCase())}
  //             inputProps={{ maxLength: 4 }}
  //           />

  //           <Button
  //             variant="outlined"
  //             color="primary"
  //             size="large"
  //             startIcon={<LockOpenIcon />}
  //             onClick={handleJoinRoom}
  //             disabled={!username.trim() || !inputRoomCode.trim()}
  //             sx={{ py: 1.5, borderRadius: 2, textTransform: "none" }}
  //           >
  //             Join Room
  //           </Button>

  //           <Divider>or</Divider>

  //           <Button
  //             variant="outlined"
  //             color="secondary"
  //             size="large"
  //             onClick={handleReconnect}
  //             disabled={!username.trim() || !inputRoomCode.trim()}
  //             sx={{ py: 1.5, borderRadius: 2, textTransform: "none" }}
  //           >
  //             Reconnect
  //           </Button>
  //         </Stack>
  //       )}
  //     </Paper>
  //   </Box>
  // );

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        px: 2,
        mt: 8,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, md: 5 },
          borderRadius: theme.shape.borderRadius,
          width: "100%",
          maxWidth: { xs: "100%", md: "480px" },
          backgroundColor: theme.palette.background.paper + "CC",
          backdropFilter: "blur(5px)",
          color: theme.palette.text.primary,
        }}
      >
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{ fontWeight: 600, mb: 2 }}
        >
          Welcome to the Game
        </Typography>

        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          textColor="inherit"
          indicatorColor="primary"
          sx={{
            mb: 3,
            "& .MuiTabs-flexContainer": { justifyContent: "space-evenly" },
            backgroundColor: theme.palette.background.default,
            borderRadius: theme.shape.borderRadius,
          }}
        >
          <Tab label="Create Room" />
          <Tab label="Join Room" />
        </Tabs>

        {activeTab === 0 && (
          <Stack spacing={3}>
            {/* <TextField
              fullWidth
              label="Username"
              variant="filled"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              inputProps={{ maxLength: 12 }}
              sx={{
                input: { color: theme.palette.text.primary },
                label: { color: theme.palette.text.secondary },
                backgroundColor: theme.palette.background.default,
                borderRadius: theme.shape.borderRadius,
              }}
            /> */}
            <TextField
              fullWidth
              label="Choose a username"
              variant="filled"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              inputProps={{ maxLength: 12 }}
              InputProps={{
                disableUnderline: true,
                sx: {
                  color: theme.palette.text.primary,
                  backgroundColor: theme.palette.background.default,
                  borderRadius: 1.5,
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                  "&.Mui-focused": {
                    backgroundColor: theme.palette.action.focus,
                  },
                },
              }}
              InputLabelProps={{
                sx: {
                  color: theme.palette.text.secondary,
                },
              }}
            />

            {/* <TextField
              fullWidth
              label="Total Rounds"
              type="number"
              variant="filled"
              value={totalRounds}
              onChange={(e) => setTotalRounds(e.target.value)}
              inputProps={{ min: 1, max: 20 }}
              sx={{
                input: { color: theme.palette.text.primary },
                label: { color: theme.palette.text.secondary },
                backgroundColor: theme.palette.background.default,
                borderRadius: theme.shape.borderRadius,
              }}
            /> */}
            <TextField
              fullWidth
              label="Total Rounds"
              type="number"
              variant="filled"
              value={totalRounds}
              onChange={(e) => setTotalRounds(e.target.value)}
              inputProps={{ min: 1, max: 20 }}
              InputProps={{
                disableUnderline: true,
                sx: {
                  color: theme.palette.text.primary,
                  backgroundColor: theme.palette.background.default,
                  borderRadius: 1.5,
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                  "&.Mui-focused": {
                    backgroundColor: theme.palette.action.focus,
                  },
                },
              }}
              InputLabelProps={{
                sx: {
                  color: theme.palette.text.secondary,
                },
              }}
            />

            <Button
              variant="contained"
              size="large"
              startIcon={<GroupAddIcon />}
              onClick={handleCreateRoom}
              disabled={!username.trim()}
            >
              Create New Room
            </Button>
          </Stack>
        )}

        {activeTab === 1 && (
          <Stack spacing={3}>
            <TextField
              fullWidth
              label="Choose a username"
              variant="filled"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              inputProps={{ maxLength: 12 }}
              InputProps={{
                disableUnderline: true,
                sx: {
                  color: theme.palette.text.primary,
                  backgroundColor: theme.palette.background.default,
                  borderRadius: 1.5,
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                  "&.Mui-focused": {
                    backgroundColor: theme.palette.action.focus,
                  },
                },
              }}
              InputLabelProps={{
                sx: {
                  color: theme.palette.text.secondary,
                },
              }}
            />
            {/* <TextField
              fullWidth
              label="Room Code"
              variant="filled"
              value={inputRoomCode}
              onChange={(e) => setInputRoomCode(e.target.value.toUpperCase())}
              inputProps={{ maxLength: 4 }}
              sx={{
                input: { color: theme.palette.text.primary },
                label: { color: theme.palette.text.secondary },
                backgroundColor: theme.palette.background.default,
                borderRadius: theme.shape.borderRadius,
              }}
            /> */}
            <TextField
              fullWidth
              label="Enter Room Code"
              variant="filled"
              value={inputRoomCode}
              onChange={(e) => setInputRoomCode(e.target.value.toUpperCase())}
              inputProps={{ maxLength: 4 }}
              InputProps={{
                disableUnderline: true,
                sx: {
                  color: theme.palette.text.primary,
                  backgroundColor: theme.palette.background.default,
                  borderRadius: 1.5,
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                  "&.Mui-focused": {
                    backgroundColor: theme.palette.action.focus,
                  },
                },
              }}
              InputLabelProps={{
                sx: {
                  color: theme.palette.text.secondary,
                },
              }}
            />
            <Button
              variant="contained"
              size="large"
              startIcon={<LockOpenIcon />}
              onClick={handleJoinRoom}
              disabled={!username.trim() || !inputRoomCode.trim()}
            >
              Join Room
            </Button>
            <Divider />
            <Button
              variant="outlined"
              size="large"
              // onClick={handleReconnect}
              onClick={handleJoinRoom}
              disabled={!username.trim() || !inputRoomCode.trim()}
            >
              Reconnect
            </Button>
          </Stack>
        )}
      </Paper>
    </Box>
  );
}

export default LobbyArea;
